<app-common-offcanvas [opened]="opened()" (close)="closeOffcanvas()">
  <div class="header">
    <app-offcanvas-pagination-title
      [title]="emailRecord?.subject ?? null"
      [currentIndex]="currentEmailMessageIndex"
      [total]="totalRows"
      [isControlsDisabled]="isMessageActionLoading || isOuterLoading"
      (moveToPrevious)="openPreviousEmail()"
      (moveToNext)="openNextEmail()"
    />
  </div>

  @if (emailRecord && !isOuterLoading) {
    <div class="content-wrapper">
      <div class="content">
        @if (showBodyWarning) {
          <div class="error-message-wrapper">
            <app-disclaimer color="orange" icon="ic-info-circle-20">
              {{ bodywarningMessage }}
            </app-disclaimer>
          </div>
        }
        @if (emailRecord.errorMessage) {
          <div class="error-message-wrapper">
            <app-disclaimer color="red" icon="ic-cancel-circle-20">
              {{ emailRecord.errorMessage }}
            </app-disclaimer>
          </div>
        }
        <div class="email-date-status">
          <div>
            <div class="title">Date & Time</div>
            <div class="text-gray900 font-weight-bold">
              {{ emailRecord.createdOn | date : 'dd MMM yyyy HH:mm' : 'en-US' }}
            </div>
          </div>

          <div>
            <div class="title">Status</div>
            <div>
              <app-ag-outgoing-message-status [status]="emailRecord.status"/>
            </div>
          </div>
        </div>

        <div class="recipients">
          <app-email-recipients [emailRecord]="emailRecord" [showSender]="true"/>
        </div>

        <div class="email-preview-wrapper preview-wrapper">
          @if (isEmailModelLoading) {
            <div class="email-body template-wrapper">
              <div class="d-flex flex-column gap-24">
                <ngx-skeleton-loader count="3" appearance="line"/>
                <div class="d-flex gap-24">
                  <ngx-skeleton-loader style="width: 50%" count="10" appearance="line"/>
                  <ngx-skeleton-loader style="width: 50%" count="10" appearance="line"/>
                </div>
              </div>
            </div>
          } @else if (htmlContent()) {
            <div class="email-body">
              <app-shadow-dom-viewer [customStyle]="customStyle" [htmlContent]="htmlContent()"/>
            </div>
          }
        </div>

        @if (emailModel?.attachments?.length) {
          <div class="attachments border border-top p-4">
            <div class="line-height-16 mb-3">
              <div class="d-flex align-items-center gap-2">
                <span class="icon ic-paperclip-20"></span>
                <span class="font-weight-600 font-size-14 line-height-16 color-gray-700">Attachments</span>
              </div>
            </div>

            <div class="d-flex flex-column">
              @for (name of emailModel?.attachments; track $index) {
                <app-file-label
                  [hideDeleteBtn]="true"
                  (downloadFile)="downloadFile(name)"
                >
                  {{ name }}
                </app-file-label>
              }
            </div>
          </div>
        }
      </div>

      <div class="controls">
        @if (resentEmailDate) {
          <div>
            <div class="title">Email was resent on</div>
            <div>
              {{ resentEmailDate | date : 'dd MMM yyyy HH:mm' : 'en-US' }}
            </div>
          </div>
        }

        @if (emailRecord.status === EmailStatus.Failed) {
          <button
            *appHasRole="['Admin']"
            class="btn btn-primary d-flex align-items-center gap-2"
            [disabled]="isMessageActionLoading"
            (click)="resendEmail()"
          >
            <i class="icon ic-sent-mail-20"></i>
            <span>Resend</span>
          </button>
        }

        <button
          *appHasRole="['Admin']"
          class="btn btn-secondary d-flex align-items-center gap-2"
          [disabled]="isMessageActionLoading"
          (click)="deleteEmail()"
        >
          <i class="icon ic-trash-20"></i>
          <span>Delete</span>
        </button>
      </div>
    </div>
  } @else if (isOuterLoading) {
    <app-loader minHeight="200"/>
  }
</app-common-offcanvas>
